import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { useHashRoute } from '@/hooks/useHashRoute';

import {
  TierDisplayLabel,
  type MemberTier,
  type TeamRole,
} from '../team.types';

interface TeamPlanBadgeProps {
  teamName: string;
  tier: MemberTier;
  role: TeamRole;
}

export function TeamPlanBadge({ teamName, tier, role }: TeamPlanBadgeProps) {
  const { setHash } = useHashRoute();

  return (
    <YStack className="gap-6">
      <YStack className="bg-surface border border-border dark:border-border-strong rounded-xl py-4 px-6 gap-4">
        <YStack>
          <h3 className="text-lg font-medium text-foreground">
            Littlebird {TierDisplayLabel[tier]}
          </h3>
          <p className="text-sm text-foreground-muted">
            Your subscription is managed by your team.
          </p>
        </YStack>

        <XStack className="flex-wrap gap-2">
          <XStack className="items-center gap-1.5 px-2.5 py-1 border border-border-strong rounded-sm text-sm text-foreground">
            <Icons.attendees className="w-3.5 h-3.5" />
            <span>{teamName}</span>
          </XStack>
          <XStack className="items-center gap-1.5 px-2.5 py-1 border border-border-strong rounded-sm text-sm text-foreground">
            <Icons.user className="w-3.5 h-3.5" />
            <span className="capitalize">{role}</span>
          </XStack>
        </XStack>

        {(role === 'owner' || role === 'admin') && (
          <XStack className="gap-3 justify-end pt-4 border-t border-border">
            <Button variant="outline" onClick={() => setHash('settings/Team')}>
              Manage Team
            </Button>
          </XStack>
        )}
      </YStack>
    </YStack>
  );
}
